import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Grid,
  MenuItem,
} from "@material-ui/core";
import {
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import { useForm } from "../../../hooks/useForm";
import {
  setSolicitud,
  setActiveStep,
  setShowForm,
  getTiposEmpadronamientoSegunEmpadronamientosActivos,
  postSolicitudMedicacion
} from "../../../actions/empadronamiento/Empadronamiento";
import { STEPPER_MEDICACION } from "../../../utils/constants";
import "moment/locale/es";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { MEDICACION_MENU_PERMISOS } from "../../../utils/permisos";


export const MedicacionDetalleTipoForm = (props) => {
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado = {},
    solicitudSeleccionada = {},
    tiposEmpadronamiento = [],
    idTipoEmpadronamiento : idTipoEmp
  } = useSelector((state) => state.empadronamiento);

  const { permisos: permisosUser } = useSelector((state) => state.auth);

  let solicitudDefault = {
    idAfiliado: "",
    idDiagnostico: "",
    idSolicitud: "",
    idTipoEmpadronamiento: idTipoEmp,
    idUsuario: "",
    tipoEmpadronamiento: "",
    fecha: new Date()
  };

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(
    !!solicitudSeleccionada ? solicitudSeleccionada : solicitudDefault
  );

  const {
    idTipoEmpadronamiento
  } = formValues;


  useEffect(() => {
    dispatch(getTiposEmpadronamientoSegunEmpadronamientosActivos(afiliadoSeleccionado?.id_afiliado));
  }, [dispatch]);

  const onSubmitHandler = () => {
    const data = {
      ...solicitudSeleccionada,
      idAfiliado: afiliadoSeleccionado?.id_afiliado,
      idTipoEmpadronamiento,
      editandoPrograma: true,
      esAuditorDisca: validarSoloUnPermiso(
        permisosUser,
        MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
      )
    };

    dispatch(postSolicitudMedicacion(data, setShowForm, solicitudSeleccionada === null, false));
    dispatch(setSolicitud(data));
  };
  const tiposEmpFiltrados = tiposEmpadronamiento?.filter(x=>x.idTipo === Number(idTipoEmp));
  return (
    <React.Fragment>
      <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
        <Grid
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "center" }}
        >

          <Grid item xs={6}>
            {tiposEmpFiltrados.length > 0 && (
              <SelectValidator
                fullWidth
                margin="normal"
                label="Programa"
                name="idTipo"
                value={idTipoEmpadronamiento}
                onChange={(e) => {
                  setearValor("idTipoEmpadronamiento", e.target.value);
                }}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {tiposEmpFiltrados.map((TipoEmpadronamiento) => (
                  <MenuItem
                    key={TipoEmpadronamiento.idTipo}
                    value={TipoEmpadronamiento.idTipo}
                  >
                    {TipoEmpadronamiento.descripcion}
                  </MenuItem>
                ))}
              </SelectValidator>
            )}
          </Grid>
        </Grid>
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          {!props.fromBandeja && <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setActiveStep(STEPPER_MEDICACION.DATOS_TITULAR));
            }}
          >
            Anterior
          </Button>}
          <Button variant="contained" color="primary" type="submit" disabled={tiposEmpadronamiento.length === 0}>
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </React.Fragment>
  );
};
